var map = {
	"./reflection/avatar/Astronaut.png": 99366,
	"./reflection/avatar/Cowboy.png": 50090,
	"./reflection/avatar/Cyborg-Racer.png": 1303,
	"./reflection/avatar/Default.png": 89372,
	"./reflection/avatar/Elf-Warrior.png": 42013,
	"./reflection/avatar/Future-Warrior.png": 25371,
	"./reflection/avatar/Mechanical-Engineer.png": 28106,
	"./reflection/avatar/Pirate.png": 32312,
	"./reflection/avatar/Samurai.png": 28733,
	"./reflection/avatar/SuperHero.png": 32766,
	"./reflection/avatar/Wizard.png": 59878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84661;